// extracted by mini-css-extract-plugin
export var blink = "_aa-2";
export var cursor = "_aa-1";
export var reactMarkdown = "_aa-3";
export var streamingText = "_aa-0";